export const DateWithoutTime = (date: Date): Date | null => {
  if (date) {
    date = new Date(date);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
  return null;
};

export const toUpperCase = (value: any) => (<string>value).toUpperCase();
const normalize = (value: string) => (<any>value).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
export const fixText = (value: string) => toUpperCase(normalize(value));
